import InfoTooltip from 'components/InfoTooltip';
import { FormattedMessage } from 'react-intl';

/**
 * Column-header label + trailing info-tooltip icon. The label truncates (ellipsis) while the icon
 * stays pinned at full size (`shrink-0`), so a narrow column clips the text — never the icon — and
 * the icon behaves like the sort caret rather than being pushed out of the cell. `min-w-0 max-w-full`
 * keeps the whole thing inside the header's own truncating wrapper. The icon is `nested`: a sortable header is
 * itself a button.
 *
 * A column using this renders its header as a node, so the column picker can no longer read the
 * label off `header` — give that column a `pickerLabel` in its meta.
 */
const TooltipHeader = ({ label, tooltip }: { label: string; tooltip: string }) => (
    <span className="flex max-w-full min-w-0 items-center gap-1">
        <span className="min-w-0 truncate">
            <FormattedMessage id={label} />
        </span>
        <span className="flex shrink-0 items-center">
            <InfoTooltip text={tooltip} nested />
        </span>
    </span>
);

export default TooltipHeader;
